module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb"
  }, [_c('p', {
    staticClass: "small",
    staticStyle: {
      "margin-bottom": "0.5em"
    }
  }, [_vm._v(_vm._s(_vm.field.label))]), _vm._v(" "), (_vm.field.type === 'select') ? _c('div', {
    staticClass: "df"
  }, _vm._l((_vm.field.options), function(option) {
    return _c('div', {
      key: option.value,
      staticClass: "mr"
    }, [_c('input', {
      attrs: {
        "disabled": "",
        "type": "radio",
        "name": _vm.field.label
      },
      domProps: {
        "value": option.value,
        "checked": _vm.field.value === option.value ? 'checked' : null
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "c-accent",
      style: ({
        'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
      }),
      attrs: {
        "for": option.label
      }
    }, [_vm._v(" " + _vm._s(option.label))])])
  }), 0) : (_vm.field.type === "tel") ? _c('p', {
    staticClass: "c-accent",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v("\n    " + _vm._s(_vm.phoneNumber(_vm.field.value, "US").getNumber("international")) + "\n  ")]) : (_vm.field.label === 'First Name') ? _c('p', {
    staticClass: "c-accent",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.titleCase(_vm.field.value)))]) : (_vm.field.label === 'Last Name') ? _c('p', {
    staticClass: "c-accent",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.titleCase(_vm.field.value)))]) : _c('p', {
    staticClass: "c-accent ",
    style: ({
      'color': _vm.org.custom_color1 == null ? '' : _vm.org.custom_color1
    })
  }, [_vm._v(_vm._s(_vm.field.value))]), _vm._v(" "), _c('hr', {
    staticClass: "mt-tiny"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-290a5f1d"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/components/ReadOnlyForm.vue
// module id = 493
// module chunks = 0